import { render, staticRenderFns } from "./ReturnItemSummary.vue?vue&type=template&id=052bc01c&scoped=true"
import script from "./ReturnItemSummary.vue?vue&type=script&lang=js"
export * from "./ReturnItemSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052bc01c",
  null
  
)

export default component.exports